/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  Alert,
  Grid,
  LinearProgress,
  Snackbar,
  TablePaginationProps,
  Typography,
  Tooltip
} from "@mui/material";
import {
  Button,
  ImportIcon,
  Search,
  RefreshIcon,
  Chip,
  ChipRemove,
  SearchIcon,
  Input,
  Card,
  ControlSuccess
} from "@forge/common";
import CloseIcon from "@mui/icons-material/Close";
import MuiPagination from "@mui/material/Pagination";
import {
  DataGrid,
  GridPagination,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid";

import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  IErrorProps,
  OptionsProduct,
  Role,
  UserDto,
  WrapperUserPermissions
} from "../../models";
import { AppDispatch, RootState } from "../../store";
import {
  getTenantDetailsByTenantId,
  getTenantLogo
} from "../../store/Tenant/tenant-actions";
import {
  deleteTenantUser,
  getUserListBasedOnForgeCustomerId,
  setroleList,
  deactivateUser,
  reactivateUser,
  resetUserPassword
} from "../../store/User/user-actions";
import "./TenantUserPage.scss";
import OrganizationHDTOKey from "../../models/apiModels/OrganizationHDTOKey";
import UserPermissions from "../../models/apiModels/UserPermissions";
import { getOrganizationByTenantID } from "../../store/Organisation/organisation-actions";
import { tenantActions } from "../../store/Tenant/tenant-slice";
import getErrorForUserPages from "../../utils/methods/getErrorForUserPages";
import { getNoRowsLabel } from "../../utils/methods/getNoRowsLabel";

import updateErrorList from "../../utils/methods/updateErrorList";
import Loader from "../Loader/Loader";
import DeleteDialog from "../SharedComponents/DeleteDialog";
import SuccessDialog from "../SharedComponents/SuccessDialog";
import ConfirmDialog from "../../utils/modals/confirm-modal/ConfirmModal";

import TenantInfoComponent from "./TenantInfoComponent";
import TemporaryDrawerforUser from "./FilterOptionUser";
import gridColumns from "../SharedComponents/helperForDataGrid/gridColumns";
import { downloadUserListExcel } from "../../utils/methods/downloadUserListExcel";

import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "./setErrorPopupsusingErrorCode";
import Title from "../SharedComponents/Title/Title";
import GetTokenValues from "../../utils/methods/GetTokenValues";
import getTenantUsersBasedOnSearchandFilterAndPersona from "../../utils/methods/getTenantUsersBasedOnSearchandFilter";
import getLoggedInUserId from "../../utils/methods/getLoggedInUserId";
import { isDeleteButtonEnabled } from "../../utils/methods/deleteDisableonPersona";
import { dataGridConfig } from "../../utils/mui-x-data-grid/config";
import GoToPage from "../../utils/mui-x-data-grid/GoToPage";
import { getUsernamebyId } from "../../utils/methods/getUsernamebyId";
import { userActions } from "../../store/User/user-slice";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../localization/keys";
import NotificationBanner from "../SharedComponents/NotificationBanner";
import { ConfigurationVariables } from "../../config";
import { USER_STATUS } from "../../utils/constants";

const POLLING_INTERVAL =
  parseInt(ConfigurationVariables.POLLING_INTERVAL) || 5000;

function TenantUserPage(props: any) {
  const location = useLocation();
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: ""
          }
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub
  };
  const loggedInUserId = getLoggedInUserId();

  // Banner state for user creation with polling
  const [showNotificationBanner, setShowNotificationBanner] = useState(false);
  const [userCreationPollingAttempts, setUserCreationPollingAttempts] =
    useState(0);
  const [newUserEmail, setNewUserEmail] = useState<string>("");
  const [isPollingActive, setIsPollingActive] = useState(false);
  const userCreationPollingRef = useRef<NodeJS.Timeout | null>(null);

  // State for user update polling
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);
  const userUpdatePollingRef = useRef<NodeJS.Timeout | null>(null);
  const userUpdateInfoRef = useRef<any>(null);
  const hasStartedPollingRef = useRef(false);
  const userUpdateAttemptsRef = useRef(0);

  const [tenantUsersToDelete, setTenantUsersToDelete] = useState<{
    customerId: string;
    userIds: Array<string>;
    singleUserDelete?: string;
  }>({
    customerId: "",
    userIds: [],
    singleUserDelete: ""
  });
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [canDeleteAllSelectedUsers, setCanDeleteAllSelectedUsers] =
    useState(true);
  const [isDeletingAllSelectedUsers, setIsDeletingAllSelectedUsers] =
    useState(false);
  const [open, setOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [deactivateSuccessDialogOpen, setDeactivateSuccessDialogOpen] =
    useState(false);
  const [activateSuccessDialogOpen, setActivateSuccessDialogOpen] =
    useState(false);
  const [resetPasswordSuccessDialogOpen, setResetPasswordSuccessDialogOpen] =
    useState(false);
  const [deactivateDialogOpen, setDeactivateDialogOpen] = useState(false);
  const [reactivateDialogOpen, setReactivateDialogOpen] = useState(false);
  const [resetPasswordDialogOpen, setResetPasswordDialogOpen] = useState(false);
  const [userToToggle, setUserToToggle] = useState<{
    userId: string;
    firstName: string;
    lastName: string;
    currentStatus: string;
  } | null>(null);
  const [userToResetPassword, setUserToResetPassword] = useState<{
    userId: string;
    firstName: string;
    lastName: string;
  } | null>(null);
  const [successUserName, setSuccessUserName] = useState<{
    firstName: string;
    lastName: string;
  } | null>(null);
  const [searchText, setSearchText] = useState("");
  const [gridData, setGridData] = useState<Array<UserDto>>([]);
  const [tenantCurrentLogo, setCurrentTenantLogo] = useState<string>("");

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [t] = useTranslation();

  const [paginationModel, setPaginationModel] = useState({
    ...dataGridConfig.paginationModel
  });

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  // on handleToastBarClose
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError
    });
  }, [errorListGlobal]);

  // Effect to set if all selected users can be deleted or not
  // If all selected users can't be deleted, then we will show a popup stating all selected users can't be deleted
  // If they can be delete, ask for user confirmation and delete the users
  useEffect(() => {
    const rowsSelected = gridData?.filter((user) =>
      selectedIds.includes(user.userId.toString())
    );
    const isAnyDeleteDisabled = rowsSelected?.some((user) => {
      // Create this props structure to use the isDeleteButtonEnabled method
      const props = {
        component: "tenantUserPage",
        isLoggedInUser: user.userId === loggedInUserId,
        userPersonaLoggedin: userPermissions.user_persona,
        cellValues: {
          row: {
            roles: user.roles
          }
        },
        OrganizationInformation: {
          permissionSet: {
            can_delete_organisation_user: false
          }
        },
        userPermissions: userPermissions
      };
      const isDeleteNotAllowed = !isDeleteButtonEnabled(props);
      return isDeleteNotAllowed;
    });

    // If any of the selected users can't be deleted, then we can't delete all selected users
    if (isAnyDeleteDisabled) {
      setCanDeleteAllSelectedUsers(false);
    } else {
      setCanDeleteAllSelectedUsers(true);
    }
  }, [selectedIds]);

  //////////////Error Handling////////////////////////

  // This property is intended to be used only for resetting the checkbox selections in the grid
  const [gridDataCopy, setGridDataCopy] = useState<any>([]);

  const userPermissionFetched = useSelector(
    (state: RootState) => state.user.isUserPermissionsFetched
  );

  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  // Get tenant Id from here
  const forgeCustomerTenantDataUserPageStore = useSelector(
    (state: RootState) => state.cart.forgeCustomerTenantDataUserPage
  );
  const tenantData = useSelector(
    (state: RootState) => state.cart.tenantDeatailsByTenantId
  );
  const tenantUsersafterPersonaFilter: Array<UserDto> = useSelector(
    (state: RootState) => state.user.tenantUsersafterPersonaFilter
  );

  // Use Effect // Only intended to set rhereows selection to default i.e no row selection
  // Intention - When grid rows change the component renders again and the the selected rows become unselected
  // Tried setting rows with copy like [...rows] but that didn't work
  useEffect(() => {
    if (gridData?.length === 0 && gridDataCopy?.length > 0) {
      setGridData(gridDataCopy);
    }
    setTenantUsersToDelete({
      customerId: "",
      userIds: []
    });
  }, [gridData]);
  // End Use effect

  const selectedproducts: OptionsProduct[] =
    forgeCustomerTenantDataUserPageStore?.products; // can be used from new response directly instead of maping

  const forgetenantID =
    forgeCustomerTenantDataUserPageStore?.id ?? tokenInfo.tenant;

  useEffect(() => {
    if (forgetenantID === "") {
    } else {
      if (userPermissions.can_read_tenant_logo) {
        // setIsLoading(true);

        dispatch(getTenantLogo(tokenInfo.tenant))
          .unwrap()
          .then((response: any) => {
            setCurrentTenantLogo(response as string);
          })
          .catch(
            (err: any) => {
              setErrorListGlobal((prevState) =>
                updateErrorList(err, [...prevState])
              );
            } //
            // seterrorgetLogo(updateErrorList(err, [...errorgetLogo]))
          )
          .finally(() => setIsLoading(false));
      } else {
        const error: IErrorProps = {
          errorCode: 403,
          errorMessage: t(localeKeyMap.noPrivilegesToReadTenantLogo)
        };
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      }

      if (userPermissions.can_read_organisation) {
        const tenantInfoToBePassed = {
          tenantID: forgetenantID,
          userPermissions: userPermissions
        };
        // setIsLoading(true);

        dispatch(getOrganizationByTenantID(tenantInfoToBePassed))
          .unwrap()
          .then(() => {})
          .catch((error: any) => {
            let newError: IErrorProps = getErrorForUserPages(error);
            // setErrorList((prevState) => [...prevState, newError]);
            setErrorListGlobal((prevState) =>
              updateErrorList(error, [...prevState])
            );
          })
          .finally(() => setIsLoading(false));
      }
    }
  }, [forgetenantID]);

  const tenantProducts = selectedproducts
    ?.map((x: OptionsProduct) => x.settings)
    .join(",")
    .toString();

  const handleClose = () => {
    setOpen(false);
  };
  const handleSuccesssConfirmationClose = () => {
    setSuccessDialogOpen(false);
  };
  const handleDeactivateSuccessClose = () => {
    setDeactivateSuccessDialogOpen(false);
    setSuccessUserName(null);
  };
  const handleActivateSuccessClose = () => {
    setActivateSuccessDialogOpen(false);
    setSuccessUserName(null);
  };

  const handleResetPasswordSuccessClose = () => {
    setResetPasswordSuccessDialogOpen(false);
    setUserToResetPassword(null);
  };
  // istanbul ignore next

  const handleDeleteConfirmation = () => {
    setOpen(false);
    setIsLoading(true);

    dispatch(deleteTenantUser(tenantUsersToDelete))
      .unwrap()
      .then(() => {
        setTenantUsersToDelete({
          customerId: "",
          userIds: []
        });
        setSelectedIds([]);
        // Clear the copy so the useEffect([gridData]) restoration logic
        // does not re-insert the deleted user when gridData briefly becomes [].
        setGridDataCopy([]);
        setSuccessDialogOpen(true);
        refreshUserList();
      })
      .catch(
        (error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        }
        // seterrordeleteUser(updateErrorList(err, [...errordeleteUser]))
      )
      .finally(() => setIsLoading(false));
  };
  const [progress, setProgress] = useState(0);
  const [toastOpen, settoastOpen] = useState(false);
  const handleCloseToast = () => {
    settoastOpen(false);
  };
  const [refreshKey, setRefreshKey] = useState(0);
  // istanbul ignore next

  /**To download user list in excel file */
  const downloadExcel = async () => {
    if (gridData && gridData.length > 0) {
      downloadUserListExcel(gridData, selectedIds);
    }
  };

  function handleDelete(
    //event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cellValues: { row: UserDto }
  ) {
    if (!cellValues?.row) return;
    
    const userIds = cellValues.row.id;
    if (!userIds) return;

    if (userPermissions.can_delete_user) {
      setTenantUsersToDelete({
        customerId: forgetenantID,
        userIds: [userIds],
        singleUserDelete: userIds
      });
      setIsDeletingAllSelectedUsers(false);
      setOpen(true);
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToDeleteUsers)
      };
      setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));
      setOpenToastError(true);
    }
  }
  // istanbul ignore next
  // Handle edit
  function handleEdit(
    //event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cellValues: { row: UserDto }
  ) {
    // TODO: Edit
    if (userPermissions.can_update_user) {
      const userDetailsToEdit = {
        CustomerId: forgetenantID,
        UserInfo: cellValues.row
      };
      navigate(`/tenant/user/edit`, {
        state: { userDetailsToEdit }
      });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToEditUsers)
      };
      const errorList: IErrorProps[] = [];
      setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));
      setOpenToastError(true);
      setOpenToastError(true);
    }
  }

  // Handle deactivate user
  function handleDeactivate(cellValues: { row: UserDto }) {
    if (!cellValues?.row) return;
    
    setUserToToggle({
      userId: cellValues.row.userId,
      firstName: cellValues.row.firstName,
      lastName: cellValues.row.lastName,
      currentStatus: cellValues.row.status ?? ""
    });
    setDeactivateDialogOpen(true);
  }

  // Handle activate user
  function handleActivate(cellValues: { row: UserDto }) {
    if (!cellValues?.row) return;
    
    setUserToToggle({
      userId: cellValues.row.userId,
      firstName: cellValues.row.firstName,
      lastName: cellValues.row.lastName,
      currentStatus: cellValues.row.status ?? ""
    });
    setReactivateDialogOpen(true);
  }

  // Handle reset password
  function handleResetPassword(cellValues: { row: UserDto }) {
    if (!cellValues?.row) return;
    
    setUserToResetPassword({
      userId: cellValues.row.userId,
      firstName: cellValues.row.firstName,
      lastName: cellValues.row.lastName
    });
    setResetPasswordDialogOpen(true);
  }

  // Handle confirm reset password
  const handleConfirmResetPassword = () => {
    if (!userToResetPassword || !forgetenantID) return;

    setIsLoading(true);
    setResetPasswordDialogOpen(false);

    dispatch(
      resetUserPassword({
        tenantId: forgetenantID,
        userId: userToResetPassword.userId
      })
    )
      .unwrap()
      .then(() => {
        setResetPasswordSuccessDialogOpen(true);
      })
      .catch((err: any) => {
        console.log("error: ", err);
         setErrorListGlobal((prevState) =>
          updateErrorList(err, [...prevState])
        );

        setUserToResetPassword(null);
      })
      .finally(() => setIsLoading(false));
  };

  const handleCloseResetPasswordDialog = () => {
    setResetPasswordDialogOpen(false);
    setUserToResetPassword(null);
  };

  // Handle confirm deactivate/activate
  const handleConfirmToggleStatus = () => {
    if (!userToToggle) return;

    // Show loader immediately
    setIsLoading(true);

    const isDeactivating = userToToggle.currentStatus === USER_STATUS.ACTIVE;
    if (isDeactivating) {
      setDeactivateDialogOpen(false);
    } else {
      setReactivateDialogOpen(false);
    }

    const action = isDeactivating ? deactivateUser : reactivateUser;

    dispatch(
      action({
        tenantId: forgetenantID,
        userId: userToToggle.userId
      })
    )
      .unwrap()
      .then(() => {
        // Refresh user list
        return dispatch(getUserListBasedOnForgeCustomerId(forgetenantID));
      })
      .then(() => {
        // Store user name for success dialog
        setSuccessUserName({
          firstName: userToToggle.firstName,
          lastName: userToToggle.lastName
        });

        if (isDeactivating) {
          setDeactivateSuccessDialogOpen(true);
        } else {
          setActivateSuccessDialogOpen(true);
        }
        setUserToToggle(null);
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
        setUserToToggle(null);
      })
      .finally(() => setIsLoading(false));
  };

  const handleCloseDeactivateDialog = () => {
    setDeactivateDialogOpen(false);
    setReactivateDialogOpen(false);
    setUserToToggle(null);
  };

  const dispatch: AppDispatch = useDispatch();
  const users = useSelector((state: RootState) => state.user.users);
  const [filteringCritera, setFilteringCriteria] = useState<Array<string>>([]);
  const [filteringGroup, setFilteringGroup] = useState<any>({
    roles: [],
    orgs: []
  });
  const numOfFilteringGroupRoles = filteringGroup?.roles?.length ?? 0;
  const [filterList, setFilterList] = useState<Array<string>>([]);
  const [filteredUsers, setFilteredUsers] = useState<Array<UserDto>>(
    useSelector((state: RootState) => state.user.users)
  );
  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state?.organisation?.hierarchicalOrganizationwKey
  );
  useEffect(() => {
    // Guard clause to check if filteringGroup is null or undefined
    if (!filteringGroup) return;
    if (
      filteringGroup &&
      filteringGroup?.roles.length &&
      !filteringGroup?.orgs.length
    ) {
      const usersAfterFilter = users.filter((item: UserDto) => {
        return item?.roles?.some(
          (role: Role) =>
            numOfFilteringGroupRoles === 0 ||
            filteringGroup.roles.includes(role?.name ?? "")
        );
      });
      setFilteredUsers(usersAfterFilter);
    } else if (!filteringGroup?.roles?.length && filteringGroup.orgs.length) {
      const usersAfterFilter = users.filter((item: UserDto) => {
        return item?.organization?.some(
          (orgs: any) =>
            filteringGroup.orgs.length === 0 ||
            filteringGroup.orgs.includes(orgs.name)
        );
      });
      setFilteredUsers(usersAfterFilter);
    } else if (filteringGroup?.roles?.length && filteringGroup.orgs.length) {
      const usersAfterFilter = users.filter((item: UserDto) => {
        return (
          item?.roles?.some(
            (role: Role) =>
              numOfFilteringGroupRoles === 0 ||
              filteringGroup.roles.includes(role.name)
          ) &&
          item?.organization?.some(
            (orgs: any) =>
              filteringGroup.orgs.length === 0 ||
              filteringGroup.orgs.includes(orgs.name)
          )
        );
      });
      setFilteredUsers(usersAfterFilter);
    } else {
      setFilteredUsers(users);
    }
  }, [filteringCritera, users, filteringGroup]);

  useEffect(() => {
    // There is no need to get user list for the tenant as the

    if (!userPermissionFetched) {
      //If user permissions are not fetched Fetch the permissions
      //For Logged in User before performing any action
      // setIsLoading(true);
      navigate("/");
      //   .unwrap()
      //   .then((response) => {
      //     const userPermissionsResponse: UserPermissions = response.result;
      //     if (userPermissionsResponse.can_read_user) {
      //       if (
      //         !(
      //           currentTenantIdOfLoadedUsers ===
      //           forgeCustomerTenantDataUserPageStore?.forgeCustomerId
      //         )
      //       ) {
      //         setIsLoadingUsers(true);
      //         dispatch(getUserListBasedOnForgeCustomerId(forgetenantID))
      //           .unwrap()
      //           .then(() => {
      //             dispatch(
      //               tenantActions.getCurrentTenantIdOfLoadedUsers(forgetenantID)
      //             );
      //           })
      //           .catch((err: any) => {
      //             seterrorgetUsers(updateErrorList(err, [...errorgetUsers]));
      //           })
      //           .finally(() => {
      //             setIsLoadingUsers(false);
      //             setIsLoading(false);
      //           });
      //       }
      //     } else {
      //       const error: IErrorProps = {
      //         errorCode: 403,
      //         errorMessage:
      //           "User Doesn't Have privileges to List the Tenant Users",
      //       };
      //       const errorList: IErrorProps[] = [];
      //       errorList.push(error);
      //       setErrorList(errorList);
      //       setOpenToastError(true);
      //       setIsLoading(false);
      //     }
      //   })
      //   .catch((err: any) => {
      //     seterrorgetUsers(updateErrorList(err, [...errorgetUsers]));
      //   })
      //   .finally(() => setIsLoading(false));
    } else {
      // Only fetch tenant details if not already loaded in store or tenant ID doesn't match
      const isTenantDataMissing = !tenantData?.tenantId;
      
      if (userPermissions.can_read_tenant && isTenantDataMissing) {
        // setIsLoadingUsers(true);
        dispatch(getTenantDetailsByTenantId({ tenantId: forgetenantID }))
          .then(() => {
            setRefreshKey((prevKey) => prevKey + 1);
            dispatch(
              tenantActions.getCurrentTenantIdOfLoadedUsers(
                forgeCustomerTenantDataUserPageStore?.forgeCustomerId
              )
            );
          })
          .catch((err: any) => {
            setErrorListGlobal((prevState) =>
              updateErrorList(err, [...prevState])
            ); // seterrorgetUsers(updateErrorList(err, [...errorgetUsers]));
          })
          .finally(() => setIsLoadingUsers(false));
      }

      /**
       * Only load user data if we're not starting polling (which will load it anyway)
       * To prevent multiple instant api calls for fetching users
       */
      const urlParams = new URLSearchParams(location.search);
      const userCreated = urlParams.get("userCreated");

      if (userCreated !== "true") {
        getTenantUserGridData();
      }
    }
  }, []);

  const refreshUserList = () => {
    if (userPermissions.can_read_user) {
      setIsLoadingUsers(true);
      dispatch(getUserListBasedOnForgeCustomerId(forgetenantID))
        .unwrap()
        .then(() => {
          setRefreshKey((prevKey) => prevKey + 1);
          dispatch(
            tenantActions.getCurrentTenantIdOfLoadedUsers(
              forgeCustomerTenantDataUserPageStore?.forgeCustomerId
            )
          );
        })
        .catch((err: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(err, [...prevState])
          );
        })
        .finally(() => setIsLoadingUsers(false));
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToListTenantUsers)
      };
      throwForBiddenError(error);
    }
  };

  const getTenantUserGridData = () => {
    setSearchText("");
    setFilteringCriteria([]);
    setFilterList([]);
    setFilteringGroup({ orgs: [], roles: [] });
    refreshUserList();
  };

  // Simple polling function that reuses existing Redux logic with silent flag
  const silentRefreshUserData = async (): Promise<boolean> => {
    if (!userPermissions.can_read_user || isPollingActive) {
      return false;
    }

    try {
      setIsPollingActive(true);

      // Use existing Redux action with silent flag to suppress loading indicator
      await dispatch(
        getUserListBasedOnForgeCustomerId({
          id: forgetenantID,
          silent: true
        })
      ).unwrap();

      return true;
    } catch (err: any) {
      return false;
    } finally {
      setIsPollingActive(false);
    }
  };

  // Simple polling control logic
  const stopPolling = () => {
    if (userCreationPollingRef.current) {
      clearInterval(userCreationPollingRef.current);
      userCreationPollingRef.current = null;
    }
    setIsPollingActive(false);
    setShowNotificationBanner(false);
    setUserCreationPollingAttempts(0);
    setNewUserEmail("");
  };

  // Check if newly created user is found in grid data
  const isNewUserFound = (userEmail: string): boolean => {
    if (!userEmail || gridData.length === 0) return false;

    const targetEmail = userEmail.toLowerCase();
    const matchIndex = gridData.findIndex((user) => {
      const currentUserEmail = user.emailId || (user as any).email;
      return currentUserEmail && currentUserEmail.toLowerCase() === targetEmail;
    });

    if (matchIndex === -1) return false;

    // Move matched user to top
    setGridData((prev) => {
      const idx = prev.findIndex((u) => {
        const e = (u as any).emailId || (u as any).email;
        return e && e.toLowerCase() === targetEmail;
      });
      if (idx === -1) return prev;
      const found = prev[idx];
      const rest = prev.filter((_, i) => i !== idx);
      return [found, ...rest];
    });

    // Force DataGrid re-render
    setRefreshKey((prev) => prev + 1);

    return true;
  };

  useEffect(() => {
    let rolesList: [
      {
        role: Role;
        count: any;
      }
    ] = [
      {
        role: { roleId: "", name: "" },
        count: 0
      }
    ];
    tenantUsersafterPersonaFilter?.forEach((user: any) => {
      user.roles.forEach((roleData: any) => {
        if (!rolesList.some((item) => item.role.roleId === roleData.roleId)) {
          rolesList.push({ role: roleData, count: 1 });
        } else {
          rolesList.map((roleCountUp) => {
            if (roleCountUp.role.roleId === roleData.roleId) {
              roleCountUp.count = roleCountUp.count + 1;
            }
          });
        }
      });
    });
    rolesList.shift();
    dispatch(setroleList(rolesList));
  }, [tenantUsersafterPersonaFilter]);

  useEffect(() => {
    let searchedUsers = getTenantUsersBasedOnSearchandFilterAndPersona(
      filteredUsers,
      searchText,
      userPermissions.user_persona
    );
    setGridData(searchedUsers);
    setRefreshKey((prev) => prev + 1);
  }, [filteredUsers]);

  const searchOnchange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    let searchedUsers = getTenantUsersBasedOnSearchandFilterAndPersona(
      filteredUsers,
      e.target.value,
      userPermissions.user_persona
    );
    setGridData(searchedUsers);
  };
  const navigate = useNavigate();
  function throwForBiddenError(error: IErrorProps) {
    const errorListData: IErrorProps[] = [];
    errorListData.push(error);
    toastErrors.current = errorListData;
    setOpenToastError(true);
  }

  function Pagination({
    page,
    onPageChange,
    className
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <div className="navigation-goto-pagination-wrapper">
        <div className="navigation-pagination">
          <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
              onPageChange(event as any, newPage - 1);
            }}
          />
        </div>
        <div className="goto-pagination-wrapper">
          <GoToPage
            pageCount={pageCount}
            handleGoToPage={(page) => {
              setPaginationModel((prevModel) => ({
                ...prevModel,
                page: page
              }));
            }}
          />
        </div>
      </div>
    );
  }
  function CustomPagination(props: any) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
  }

  // createUserHandler
  // istanbul ignore next
  const createUserHandler = () => {
    if (userPermissions.can_create_user) {
      navigate("/tenant/user/create", { state: { forgetenantID } });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToCreateTenantUsers)
      };
      throwForBiddenError(error);
    }
  };

  // istanbul ignore next
  // reset GridRowSelectionHandler
  const resetGridRowSelectionHandler = () => {
    setTenantUsersToDelete({
      customerId: "",
      userIds: []
    });
    setGridData([]);
  };

  // istanbul ignore next
  // delete CustomersHandler
  const deleteCustomersHandler = () => {
    if (userPermissions.can_delete_user) {
      setOpen(true);
      setIsDeletingAllSelectedUsers(true);
      setTenantUsersToDelete({
        customerId: forgetenantID,
        userIds: selectedIds
      });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToDeleteUsers)
      };
      throwForBiddenError(error);
    }
  };

  // istanbul ignore next
  // filtering CriteriaChangeHandler
  const filteringCriteriaChangeHandler = (dataFromFilter: any) => {
    setFilteringCriteria(dataFromFilter.roles);
    setFilteringGroup(dataFromFilter);
    const arrays = Object.values(dataFromFilter)
      .filter(Array.isArray)
      ?.reduce((acc, val) => acc.concat(val), []);
    setFilterList(arrays);
  };
  // istanbul ignore next
  // customLocaleText
  const customLocaleText = {
    noRowsLabel: getNoRowsLabel(searchText, filteringCritera.length !== 0)
  };

  // Error handling handlers
  // istanbul ignore next

  // istanbul ignore next
  // on DialogForNOURLCloseHandler

  useEffect(() => {
    let filteredUsersbyPersona = getTenantUsersBasedOnSearchandFilterAndPersona(
      [...users],
      "",
      userPermissions.user_persona
    );
    dispatch(
      userActions.tenantUsersafterPersonaFilterforFilterCount(
        filteredUsersbyPersona
      )
    );
  }, [users]);

  useEffect(() => {
    const xpathResult = document.evaluate(
      "//input[@placeholder='Search']/../div",
      document, // context node
      null, // namespace resolver
      XPathResult.ANY_TYPE, // result type
      null // result
    ); // Replace with the actual class or identifier

    const svgElement = xpathResult.iterateNext() as HTMLElement; // Get the actual DOM node

    const handleSvgClick = () => {
      // Your custom logic here
      setSearchText("");
    };

    if (svgElement) {
      svgElement.addEventListener("click", handleSvgClick);
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      if (svgElement) {
        svgElement.removeEventListener("click", handleSvgClick);
      }
    };
  }, []);

  // Handle user creation banner with polling
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const userCreated = urlParams.get("userCreated");
    const userEmail = urlParams.get("userEmail");

    if (userCreated === "true" && userEmail) {
      setShowNotificationBanner(true);
      setUserCreationPollingAttempts(0);
      setNewUserEmail(userEmail);

      // Remove the parameters from URL without triggering a re-render
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);

      // Start polling for new user
      const startPolling = () => {
        // Start polling attempts counter
        setUserCreationPollingAttempts(1);
        // Start interval polling
        userCreationPollingRef.current = setInterval(() => {
          setUserCreationPollingAttempts((prev) => {
            const nextAttempt = prev + 1;

            // Max attempts reached, stop polling
            if (nextAttempt >= 10) {
              stopPolling();
              return 0;
            }

            // Trigger silent user data refresh
            silentRefreshUserData().then((success) => {
              if (!success) {
                stopPolling();
              }
            });

            return nextAttempt;
          });
        }, POLLING_INTERVAL);
      };

      startPolling();
    }

    // Cleanup interval on unmount
    return () => {
      stopPolling();
    };
  }, [location.search]);

  // Stop polling and hide banner when the newly created user is found in the grid
  useEffect(() => {
    if (
      !showNotificationBanner ||
      !newUserEmail ||
      userCreationPollingAttempts === 0
    ) {
      return;
    }

    if (isNewUserFound(newUserEmail)) {
      stopPolling();
    }
  }, [
    gridData,
    showNotificationBanner,
    userCreationPollingAttempts,
    newUserEmail
  ]);

  // Simple polling for user updates - triggered by sessionStorage
  useEffect(() => {
    // Prevent running if already started
    if (hasStartedPollingRef.current) {
      return;
    }

    // Check sessionStorage for user update info
    const userUpdateInfoStr = sessionStorage.getItem("userUpdateInfo");

    if (!userUpdateInfoStr) {
      return;
    }

    const userUpdateInfo = JSON.parse(userUpdateInfoStr);

    // Store in ref so it persists across re-renders
    userUpdateInfoRef.current = userUpdateInfo;

    // Mark that we've started polling
    hasStartedPollingRef.current = true;

    // Reset attempts counter
    userUpdateAttemptsRef.current = 0;

    // Clear sessionStorage immediately so it doesn't re-trigger on re-render
    sessionStorage.removeItem("userUpdateInfo");

    const maxAttempts = 10;

    const stopUserUpdatePolling = () => {
      if (userUpdatePollingRef.current) {
        clearInterval(userUpdatePollingRef.current);
        userUpdatePollingRef.current = null;
      }
      setShowUpdateBanner(false);
      hasStartedPollingRef.current = false;
      userUpdateInfoRef.current = null;
      userUpdateAttemptsRef.current = 0;
    };

    const poll = () => {
      // Use ref value which persists
      const currentUserUpdateInfo = userUpdateInfoRef.current;
      if (!currentUserUpdateInfo) {
        stopUserUpdatePolling();
        return;
      }

      // Increment attempts using ref
      userUpdateAttemptsRef.current++;
      const currentAttempt = userUpdateAttemptsRef.current;

      if (!userPermissions.can_read_user) {
        stopUserUpdatePolling();
        return;
      }

      dispatch(
        getUserListBasedOnForgeCustomerId({
          id: forgetenantID,
          silent: true
        })
      )
        .unwrap()
        .then((response) => {
          const freshUsers = response?.result || response || [];
          const user = freshUsers.find(
            (u: any) => u.userId === currentUserUpdateInfo.userId
          );

          if (!user) {
            return;
          }

          // Compare roles
          const editedRoles = currentUserUpdateInfo.roles || [];
          const apiUserRoles = user.roles?.map((r: any) => r.roleId) || [];
          const rolesMatch =
            editedRoles.length === apiUserRoles.length &&
            editedRoles.every((roleId: string) =>
              apiUserRoles.includes(roleId)
            );

          // Compare organizations
          const editedOrgs =
            currentUserUpdateInfo.organization?.map((o: any) => o.id) || [];
          const apiUserOrgs = user.organization?.map((o: any) => o.id) || [];
          const orgsMatch =
            editedOrgs.length === apiUserOrgs.length &&
            editedOrgs.every((orgId: string) => apiUserOrgs.includes(orgId));

          if (rolesMatch && orgsMatch) {
            stopUserUpdatePolling();
          } else if (currentAttempt >= maxAttempts) {
            stopUserUpdatePolling();
          }
        })
        .catch((err) => {
          stopUserUpdatePolling();
        });
    };

    // Show banner immediately
    setShowUpdateBanner(true);

    // Set up interval first (poll will be called by the interval)
    userUpdatePollingRef.current = setInterval(poll, POLLING_INTERVAL);

    // Cleanup - but DON'T clear interval if we're just remounting (React StrictMode)
    return () => {
      // Only cleanup if polling is actually done (hasStartedPollingRef will be false)
      // This prevents React StrictMode from clearing the interval on dev remounts
      if (!hasStartedPollingRef.current && userUpdatePollingRef.current) {
        clearInterval(userUpdatePollingRef.current);
        userUpdatePollingRef.current = null;
        setShowUpdateBanner(false);
      }
    };
  }, []); // Run only on mount - sessionStorage check is one-time

  const removeFilter = (item: string) => {
    setFilteringCriteria(filteringCritera.filter((x) => x != item));
    setFilterList(filterList.filter((x) => x != item));

    const filteredObj = { ...filteringGroup };
    Object.keys(filteredObj).forEach((el: any) => {
      if (filteredObj[el] && Array.isArray(filteredObj[el])) {
        filteredObj[el] = filteredObj[el].filter((ele: any) => ele !== item);
      }
    });
    setFilteringGroup(filteredObj);
  };
  // End error handling handlers

  const custProps: any = {
    handleEdit: handleEdit,
    handleDelete: handleDelete,
    handleDeactivate: handleDeactivate,
    handleActivate: handleActivate,
    handleResetPassword: handleResetPassword,
    component: "tenantUserPage",
    CustomerId: forgetenantID,
    CustomerDetails: forgeCustomerTenantDataUserPageStore,
    to: "/tenant/user/info",
    t: t
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <Title
          title={tenantData.tenantName}
          className="p-t15 p-b15"
          buttonRequired={false}
        />
        <h6 style={{ paddingTop: "4.15vh" }}>&nbsp;</h6>
      </div>
      <Snackbar
        open={toastOpen}
        onClose={handleCloseToast}
        sx={{ width: "30%" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity="info"
          onClose={handleCloseToast}
          className="exportToast"
        >
          <Grid item md={12}>
            <Typography
              sx={{ width: "200px", padding: " 5 0 5 0" }}
              className="exportToastMessage"
            >
              {t(localeKeyMap.datasheetFileName)}
            </Typography>
            <LinearProgress
              sx={{
                width: "100%",
                borderRadius: "4px 2px 2px 4px",
                backgroundColor: "#707070"
              }}
              variant="determinate"
              value={progress}
            />
            <Typography
              color="inherit"
              sx={{ width: "200px" }}
              className="exportToastMessage"
            >
              {t(localeKeyMap.downloading)}...
            </Typography>
          </Grid>
        </Alert>
      </Snackbar>
      <TenantInfoComponent className={""} currentLogo={tenantCurrentLogo} />
      <div style={{ height: "1vh" }}></div>
      <Card>
        {/* // This div is for buttons */}
        <div className="">
          <div
            className={`d-flex align-items-center justify-items-between p-15`}
          >
            <div className="data_top_part">
              {/* <h3 className="component-title">USER LIST &nbsp;</h3> */}

              <h3 className="menu-title-1">
                {t(localeKeyMap.userList)} &nbsp;
              </h3>
              <h3 className="subtitle-2">
                {" "}
                | {gridData.length} {t(localeKeyMap.users)}
              </h3>
            </div>
            <div className={`d-flex align-items-center spacing-g-10 p-r20`}>
              <Input
                id="search"
                placeholder={t(localeKeyMap.search)}
                prefix={<SearchIcon strokeWidth={2} />}
                size="regular"
                onChange={searchOnchange}
                data-testid="search"
              />

              <TemporaryDrawerforUser
                isFilterDisabled={isLoading || isLoadingUsers}
                filteringGroup={filteringGroup}
                onFilteringCriteriaChange={filteringCriteriaChangeHandler}
                hierarchicalOrganizationwKey={hierarchicalOrganizationwKey}
                comp="tenantUserPage"
              />
              <Button
                data-testid="RefreshButton"
                icon={<RefreshIcon strokeWidth={2} />}
                iconPosition="left"
                label={t(localeKeyMap.refresh)}
                onClick={getTenantUserGridData}
                size="regular"
                variant="tertiary"
                aria-label={t(localeKeyMap.refresh)}
              />

              <Button
                icon={<ImportIcon strokeWidth={2} />}
                iconPosition="left"
                label={t(localeKeyMap.downloadExcel)}
                data-testid="downloadExcel"
                onClick={() => downloadExcel()}
                size="regular"
                variant="tertiary"
                aria-label={t(localeKeyMap.downloadExcel)}
              />

              <Button
                variant="primary"
                onClick={createUserHandler}
                disabled={!userPermissions.can_create_user}
              >
                {t(localeKeyMap.createNewUser)}
              </Button>
            </div>
          </div>
        </div>

        <div className={`d-flex align-items-center p-10 border-div`}>
          {filterList.map(
            (item, index) =>
              index < 5 && (
                <Chip onClick={function noRefCheck() {}} className="theme-chip">
                  {item}
                  <ChipRemove
                    onClick={() => removeFilter(item)}
                    className="theme-chip"
                    data-testid="removeFilter"
                  >
                    {t(localeKeyMap.remove)}
                  </ChipRemove>
                </Chip>
              )
          )}
          {filterList.length > 5 && (
            <>
              {" "}
              <Chip className="dot-item">..</Chip>
              <Tooltip title={filterList.slice(5).join(", ")} arrow={true}>
                <div>
                  <Chip>{`+${(filterList.length - 5).toString()}`}</Chip>
                </div>
              </Tooltip>
            </>
          )}
        </div>

        {/* User Creation Banner - Positioned before DataGrid */}
        <NotificationBanner
          isVisible={showNotificationBanner}
          type="warning"
          hideIcon={false}
          titleLocaleKey="userCreationInProgress"
          descriptionLocaleKey="userCreationInProgressDescription"
        />

        {/* User Update Banner - Positioned before DataGrid */}
        <NotificationBanner
          isVisible={showUpdateBanner}
          type="warning"
          hideIcon={false}
          titleLocaleKey="userUpdateInProgress"
          descriptionLocaleKey="userUpdateInProgressDescription"
        />

        <DataGrid
          key={refreshKey}
          loading={
            isLoadingUsers &&
            !isPollingActive &&
            !showNotificationBanner &&
            !showUpdateBanner
          }
          checkboxSelection
          // rowHeight={25}
          // columnHeaderHeight={20}
          columns={gridColumns(custProps)}
          // columns={columns}
          rows={gridData}
          //rows={filteredUsers}
          pagination
          slots={{
            pagination: CustomPagination
          }}
          autoHeight={true}
          disableColumnMenu={true}
          onRowSelectionModelChange={(ids) => {
            if (gridData.length !== gridDataCopy.length) {
              setGridDataCopy(gridData);
            }

            // Set  selected ids .This is used while downloading selected rows through checkboxes
            setSelectedIds(Object.values(ids.map((id) => id.toString())));
          }}
          isRowSelectable={(params: any) => {
            // logged in user should not be selectable
            const isRowSelectable = loggedInUserId !== params.row.id;
            return isRowSelectable;
          }}
          localeText={customLocaleText}
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          pageSizeOptions={dataGridConfig.pageSizeOptions}
          sx={dataGridConfig.sx}
        />
      </Card>
      {/* </Grid>
      </Grid> */}
      {/* </Grid> */}
      {selectedIds.length > 0 && (
        <div className="action-bar-tenant-users">
          <div>
            <Button
              className="cancelButtonDelete"
              onClick={resetGridRowSelectionHandler}
              variant="quiet-primary"
            >
              {t(localeKeyMap.cancel)}
            </Button>
          </div>
          <div>
            {selectedIds.length > 1 && (
              <Button
                className="deleteButton"
                variant="primary"
                onClick={deleteCustomersHandler}
              >
                {t(localeKeyMap.delete)}
              </Button>
            )}
          </div>
        </div>
      )}
      {/* </Paper> */}
      {open && canDeleteAllSelectedUsers && isDeletingAllSelectedUsers && (
        <DeleteDialog
          open={open}
          title={
            selectedIds.length == 1
              ? `${t(localeKeyMap.delete)} ${getUsernamebyId(
                  selectedIds[0],
                  gridData
                )}`
              : `${t(localeKeyMap.delete)} ${t(localeKeyMap.users)}`
          }
          handleClose={handleClose}
          DeleteConfirmationMessage={
            selectedIds.length > 1
              ? t(localeKeyMap.deleteMultipleUsers, {
                  count: selectedIds.length
                })
              : t(localeKeyMap.deleteSingleUser)
          }
          subTitle={t(localeKeyMap.pleaseConfirm)}
          handleDeleteConfirmation={handleDeleteConfirmation}
        />
      )}

      {open &&
        tenantUsersToDelete.singleUserDelete != "" &&
        !isDeletingAllSelectedUsers && (
          <DeleteDialog
            open={open}
            title={`${t(localeKeyMap.delete)} ${getUsernamebyId(
              tenantUsersToDelete.singleUserDelete || "",
              gridData
            )}`}
            handleClose={handleClose}
            DeleteConfirmationMessage={t(localeKeyMap.deleteSingleUser)}
            subTitle={t(localeKeyMap.pleaseConfirm)}
            handleDeleteConfirmation={handleDeleteConfirmation}
          />
        )}
      {/* The "SuccessDialog" Dialog name is misleading. It is just a dialog to show information with a ok,cancel at top*/}
      {open && !canDeleteAllSelectedUsers && isDeletingAllSelectedUsers && (
        <SuccessDialog
          open={open}
          title={t(localeKeyMap.deleteUnsuccessful)}
          SuccessConfirmationMessage={t(
            localeKeyMap.noPermissionDeleteSelected
          )}
          handleClose={handleClose}
        />
      )}
      {/* Delete Success Dialog */}
      {successDialogOpen && (
        <SuccessDialog
          open={successDialogOpen}
          title={t(localeKeyMap.successfullyDeleted)}
          SuccessConfirmationMessage={t(localeKeyMap.userDeletedSuccessfully)}
          handleClose={handleSuccesssConfirmationClose}
        />
      )}
      {/* Deactivate Success Dialog */}
      {deactivateSuccessDialogOpen && successUserName && (
        <SuccessDialog
          open={deactivateSuccessDialogOpen}
          title={
            <>
              <ControlSuccess />
              {t(localeKeyMap.success)}
            </>
          }
          successMessage={
            <span>
              {t(localeKeyMap.user)}{" "}
              <strong>
                {successUserName.firstName} {successUserName.lastName}
              </strong>{" "}
              {t(localeKeyMap.deactivatedSuccessfully)}
            </span>
          }
          handleClose={handleDeactivateSuccessClose}
        />
      )}
      {/* Activate Success Dialog */}
      {activateSuccessDialogOpen && successUserName && (
        <SuccessDialog
          open={activateSuccessDialogOpen}
          title={
            <>
              <ControlSuccess />
              {t(localeKeyMap.success)}
            </>
          }
          successMessage={
            <span>
              {t(localeKeyMap.user)}{" "}
              <strong>
                {successUserName.firstName} {successUserName.lastName}
              </strong>{" "}
              {t(localeKeyMap.activatedSuccessfully)}
            </span>
          }
          handleClose={handleActivateSuccessClose}
        />
      )}
      {/* Reset Password Success Dialog */}
      {resetPasswordSuccessDialogOpen && (
        <SuccessDialog
          open={resetPasswordSuccessDialogOpen}
          title={
            <>
              <ControlSuccess />
              {t(localeKeyMap.success)}
            </>
          }
          successMessage={
            <span>
              {t(localeKeyMap.passwordResetSuccessfully)}
            </span>
          }
          handleClose={handleResetPasswordSuccessClose}
        />
      )}
      {/* Deactivate User Dialog */}
      {deactivateDialogOpen &&
        userToToggle &&
        userToToggle.currentStatus === USER_STATUS.ACTIVE && (
          <ConfirmDialog
            open={deactivateDialogOpen}
            dialogTitle={t(localeKeyMap.deactivateUser)}
            dialogContentText={
              <>
                {t(localeKeyMap.youAreChangingUserStatusOf)}{" "}
                <strong>
                  {userToToggle.firstName} {userToToggle.lastName}
                </strong>{" "}
                {t(localeKeyMap.fromActiveToInactive)}
                <br />
                <br />
                {t(localeKeyMap.doYouWantToProceed)}
              </>
            }
            onCloseClick={handleCloseDeactivateDialog}
            onCancelClick={handleCloseDeactivateDialog}
            onConfirmClick={handleConfirmToggleStatus}
            primaryBtnText={t(localeKeyMap.confirm)}
          />
        )}
      {/* Reactivate User Dialog */}
      {reactivateDialogOpen &&
        userToToggle &&
        userToToggle.currentStatus === USER_STATUS.INACTIVE && (
          <ConfirmDialog
            open={reactivateDialogOpen}
            dialogTitle={t(localeKeyMap.activateUser)}
            dialogContentText={
              <>
                {t(localeKeyMap.youAreChangingUserStatusOf)}{" "}
                <strong>
                  {userToToggle.firstName} {userToToggle.lastName}
                </strong>{" "}
                {t(localeKeyMap.fromInactiveToActive)}
                <br />
                <br />
                {t(localeKeyMap.doYouWantToProceed)}
              </>
            }
            onCloseClick={handleCloseDeactivateDialog}
            onCancelClick={handleCloseDeactivateDialog}
            onConfirmClick={handleConfirmToggleStatus}
            primaryBtnText={t(localeKeyMap.confirm)}
          />
        )}
      {/* Reset Password Dialog */}
      {resetPasswordDialogOpen && userToResetPassword && (
        <ConfirmDialog
          open={resetPasswordDialogOpen}
          dialogTitle={t(localeKeyMap.resetPassword)}
          dialogContentText={
            <>
              {t(localeKeyMap.resetPasswordConfirmation)}{" "}
              <strong>
                {userToResetPassword.firstName} {userToResetPassword.lastName}
              </strong>
              ?
            </>
          }
          onCloseClick={handleCloseResetPasswordDialog}
          onCancelClick={handleCloseResetPasswordDialog}
          onConfirmClick={handleConfirmResetPassword}
          primaryBtnText={t(localeKeyMap.confirm)}
        />
      )}
      {isLoading && <Loader />}
      {/* {MoreInfo && <MoreInfo />} */}
      {/* /// Error handling logic */}
      {/* {!isLoading && !isLoadingUsers && (
        //#mockingdata

        // <DialogForError
        //   open={openDialogServerError}
        //   onClose={onDialogForServerCloseHandler}
        //   errorList={errorList}
        //   errorType="serverError"
        // />
        <div></div>
      )} */}
      {/* /// Open NoURL error */}
      {/* {!isLoading && !isLoadingUsers && (
        //#mockingdata

        // <DialogForError
        //   open={openDialogNoURLError}
        //   onClose={onDialogForNOURLCloseHandler}
        //   errorList={errorList}
        //   errorType="noURLFoundError"
        // />
        <div></div>
      )} */}
      {/* /// Open Toast error */}
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {/* /// End error handling logic */}
    </>
  );
}

export default TenantUserPage;
